/**
 * The ui-components PhoneNumber field stores the number as displayed ("+43 664 1234567").
 * The backend expects digits only, so strip everything else before validating or submitting.
 * @param phoneNumber - Phone number as entered in the PhoneNumber field
 * @returns {string} - Digits of the phone number, e.g. "436641234567"
 */
export const stripPhoneNumberFormatting = (phoneNumber: string) => phoneNumber.replace(/\D/g, '');
